document.querySelectorAll('.js-tab-navigation').forEach(tablist => {
	const buttons = Array.from(tablist.querySelectorAll('.js-tab-navigation-button'));
	const tabIdentifiers = buttons
		.map(button => button.getAttribute('data-identifier'))
		.filter(identifier => identifier !== null);

	// Set role and aria-labelledby on tab panels
	buttons.forEach(button => {
		const identifier = button.getAttribute('data-identifier');
		const panel = document.getElementById(identifier);
		if (panel) {
			panel.setAttribute('role', 'tabpanel');
			panel.setAttribute('aria-labelledby', 'tab-' + identifier);
			if (!panel.hasAttribute('tabindex')) {
				panel.setAttribute('tabindex', '0');
			}
		}
	});


	function activateTab(button) {
		const identifier = button.getAttribute('data-identifier');

		buttons.forEach(btn => {
			btn.classList.remove('js-tab-navigation-button--active');
			btn.setAttribute('aria-selected', 'false');
			btn.setAttribute('tabindex', '-1');
		});
		button.classList.add('js-tab-navigation-button--active');
		button.setAttribute('aria-selected', 'true');
		button.setAttribute('tabindex', '0');

		document.querySelectorAll('.js-tab-content').forEach(content => {
			const contentIdentifier = content.getAttribute('data-identifier');

			if (!contentIdentifier || !tabIdentifiers.includes(contentIdentifier)) {
				return;
			}

			if (contentIdentifier === identifier && identifier !== null) {
				content.classList.add('css-tab-show-1');
				content.classList.remove('css-tab-show-0');
			} else {
				content.classList.add('css-tab-show-0');
				content.classList.remove('css-tab-show-1');
			}
		});

		window.dispatchEvent(new Event('resize'));
	}

	buttons.forEach((button, index) => {
		button.addEventListener('click', function () {
			activateTab(this);
		});

		button.addEventListener('keydown', function (e) {
			let newIndex;

			if (e.key === 'ArrowRight') {
				newIndex = (index + 1) % buttons.length;
			} else if (e.key === 'ArrowLeft') {
				newIndex = (index - 1 + buttons.length) % buttons.length;
			} else if (e.key === 'Home') {
				newIndex = 0;
			} else if (e.key === 'End') {
				newIndex = buttons.length - 1;
			} else {
				return;
			}

			e.preventDefault();
			activateTab(buttons[newIndex]);
			buttons[newIndex].focus();
		});
	});
});
setTimeout(() => {
	const url = (document.URL.split('#').length > 1) ? document.URL.split('#')[1] : null;
	if(url !== null){
		const activateButton = document.getElementById(url);
		if(activateButton){
			activateButton.click();
		}
	}
}, 250);
